import { render } from "./InquiryCreatePage.vue?vue&type=template&id=cc6fac92"
import script from "./InquiryCreatePage.vue?vue&type=script&lang=js"
export * from "./InquiryCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__